<template>
    <div v-if="loaded">
        <div class="card-box">
            <div class="head">
                <div class="title">
                    <img src="/images/moedas-icons/phone.svg" alt="" />
                    <h4>Ver Telefone</h4>
                </div>
                <span class="cred-coins"><img src="/images/icone_moeda.svg" alt="" />{{ typeAmount('view_phone_number') }}</span>
            </div>
            <div class="body">
                <p>Consiga visualizar o número de telefone e contato do seu roommate para facilitar a negociação.</p>
            </div>
            <div class="bottom" v-if="host_panel" >
                <a href="/host/roommates-compativeis" class="btn btn-success waves-effect waves-light">Pesquisar Roommates</a>
            </div>
        </div>

        <div class="card-box">
            <div class="head">
                <div class="title">
                    <img src="/images/moedas-icons/boost-ad.svg" alt="" />
                    <h4>Impulsionamento por Tempo</h4>
                </div>
                <span class="cred-coins"><img src="/images/icone_moeda.svg" alt="" />{{ typeAmount('boost_ad_time') }}</span>
            </div>
            <div class="body">
                <p>Impulsione seus anúncios por um tempo determinado em nossa plataforma,
                    recebendo mais contatos de pessoas interessada neste período.</p>
            </div>
            <div class="bottom">
                <a href="/host/meus-anuncios" class="btn btn-success waves-effect waves-light">Ir para Meus Anúncios</a>
                <button class="btn btn-link" @click="openBoostAdModal()">Saiba Mais</button>
            </div>
        </div>

        <div class="card-box">
            <div class="head">
                <div class="title">
                    <img src="/images/moedas-icons/boost-ad.svg" alt="" />
                    <h4>Impulsionamento por Contatos</h4>
                </div>
                <span class="cred-coins"><img src="/images/icone_moeda.svg" alt="" />{{ typeAmount('boost_ad_contact') }}</span>
            </div>
            <div class="body">
                <p>Impulsione seus anúncios em nossa plataforma e seja cobrado apenas quando receber contatos de pessoas interessadas em seu anúncio.</p>
            </div>
            <div class="bottom" v-if="host_panel">
                <a href="/host/meus-anuncios" class="btn btn-success waves-effect waves-light">Ir para Meus Anúncios</a>
                <button class="btn btn-link" @click="openBoostAdModal()">Saiba Mais</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        host_panel: {
            default: true,
            type: Boolean,
            required: false
        },
    },
    data() {
        return {
            types: [],
            loaded: false,
        };
    },
    methods: {
        openBoostAdModal() {
            EventBus.$emit('open-modal', 'credits-boost-ad-modal');
        },
        getAll() {
            axios.get('/moedas/types').then(res => {
                this.types = res.data;
                this.loaded = true;
            });
        },
        typeAmount(label) {
            let sel = this.types.filter((item) => {
                return item.label == label;
            });
            if  (sel.length > 0)
                return Math.abs(sel[0].amount);

            return '--'
        }
    },
    created() {
        this.getAll();
    }
}
</script>

<style lang="scss" scoped>
    .card-box {
        width: 400px;
        display: inline-flex;
        flex-direction: column;
        margin-right: 15px;
    }
    .head {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
            display: flex;
            align-items: center;
        }

        img {
            width: 25px;
            height: 25px;
            margin-right: 10px;
        }

        h4 {
            margin: 0 !important;
        }

        .cred-coins {
            margin-right: 0;
            font-weight: bolder;
            font-size: 16px;
            color: #FAC73C;
            display: flex;
            align-items: center;

            img {
                margin-right: 5px;
                width: 15px;
                height: 15px;
            }
        }
    }

    .body {
        margin: 20px 0 30px 0;
        white-space: initial;

        p {
            height: 60px;
        }
    }

    .bottom {
        display: flex;
        justify-content: space-between;

        .btn-link {
            color: #4BD396;
        }
    }
</style>